define([
    "./nlgPageTitleModule",
    "./nlgPageTitleDirective",
], function () {
});